(function () {
  var header = document.querySelector('header[data-theme]');
  if (!header) return;

  var nav = header.querySelector('[data-redesign-nav]');
  if (!nav) return;
  var meny = nav.querySelector('[data-nav-meny]');
  var items = nav.querySelector('[data-nav-items]');
  if (!meny || !items) return;

  // Width measurement -----------------------------------------------
  // Container has overflow:hidden; width is set inline based on state.
  // Collapsed width MATCHES the logo's footprint — so the morph snaps
  // between two same-sized pills (logo pill ↔ "Meny" pill) instead of
  // the meny pill being whatever width "Meny" + padding happens to be.
  // Measured once on init, re-measured when fonts / logo image settle
  // (text widths shift after font-swap; logo width changes after image
  // decode).

  var widths = { full: 0, collapsed: 0 };
  var logo = items.querySelector('[data-nav-logo]');

  function measureWidths() {
    var prevTransition = nav.style.transition;
    nav.style.transition = 'none';
    nav.style.width = 'auto';
    meny.style.width = ''; // measure intrinsic, not the previously-applied size

    // items wrapper is the only flex child contributing to nav's natural
    // size (meny is position:absolute). offsetWidth includes its padding.
    widths.full = items.offsetWidth;
    widths.collapsed = logo ? logo.offsetWidth : meny.offsetWidth;

    // Pin the meny button to the collapsed width so its content (centered) sits
    // in the same footprint the logo will reappear into on expand.
    meny.style.width = widths.collapsed + 'px';

    // Apply the correct state — still inside the transition: none window,
    // so this update doesn't animate from the intermediate 'auto' value
    // we used for measuring. applyState handles both width and inert.
    applyState();

    nav.offsetHeight; // eslint-disable-line no-unused-expressions
    nav.style.transition = prevTransition;
  }

  // State ------------------------------------------------------------

  function isScrolled() {
    return header.getAttribute('data-scrolled') === 'true';
  }

  function isExpanded() {
    return header.getAttribute('data-nav-expanded') === 'true';
  }

  function applyState() {
    if (!widths.full || !widths.collapsed) return;
    var collapsed = isScrolled() && !isExpanded();
    nav.style.width = (collapsed ? widths.collapsed : widths.full) + 'px';

    // Pull the items wrapper (logo + nav links) out of the a11y tree and tab
    // order while it's visually hidden. CSS pointer-events:none + opacity:0
    // already prevents mouse interaction; without `inert` a screen reader
    // user could still tab through invisible links.
    if (collapsed) {
      items.setAttribute('inert', '');
    } else {
      items.removeAttribute('inert');
    }
  }

  function expand() {
    if (!isScrolled() || isExpanded()) return;
    header.setAttribute('data-nav-expanded', 'true');
    meny.setAttribute('aria-expanded', 'true');
    applyState();
  }

  function collapse() {
    if (!isExpanded()) return;
    // Focus inside nav becomes hidden when we collapse — move it to the
    // meny pill (which is about to become the only visible element).
    if (nav.contains(document.activeElement) && document.activeElement !== meny) {
      meny.focus({ preventScroll: true });
    }
    header.setAttribute('data-nav-expanded', 'false');
    meny.setAttribute('aria-expanded', 'false');
    applyState();
  }

  // Triggers ---------------------------------------------------------

  // Hover & keyboard focus on the nav (which in collapsed state IS just the
  // meny pill, since items have pointer-events:none). Once expanded, hovering
  // anywhere inside nav keeps it open — mouseleave does NOT collapse, that's
  // reserved for scroll movement.
  nav.addEventListener('mouseenter', expand);
  nav.addEventListener('focusin', expand);

  // Tap on meny — first tap expands without navigating. The button has no
  // href so click won't navigate by default; we still preventDefault to be
  // safe across user-agent quirks.
  meny.addEventListener('click', function (e) {
    if (isExpanded()) return;
    e.preventDefault();
    expand();
  });

  // Scroll movement while in scrolled+expanded → collapse.
  var lastScrollY = window.scrollY;
  window.addEventListener(
    'scroll',
    function () {
      if (!isScrolled() || !isExpanded()) {
        lastScrollY = window.scrollY;
        return;
      }
      if (window.scrollY !== lastScrollY) {
        collapse();
      }
      lastScrollY = window.scrollY;
    },
    { passive: true }
  );

  // Watch data-scrolled flips so we re-apply the right width when the
  // header transitions in/out of the scrolled state. Also reset
  // data-nav-expanded when scrolling back to the top.
  var observer = new MutationObserver(function () {
    if (!isScrolled() && isExpanded()) {
      header.setAttribute('data-nav-expanded', 'false');
      meny.setAttribute('aria-expanded', 'false');
    }
    applyState();
  });
  observer.observe(header, {
    attributes: true,
    attributeFilter: ['data-scrolled'],
  });

  // Init -------------------------------------------------------------

  measureWidths();

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(measureWidths);
  }

  Array.from(items.querySelectorAll('img')).forEach(function (img) {
    if (img.complete) return;
    img.addEventListener('load', measureWidths, { once: true });
  });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(measureWidths, 150);
  });
})();
